var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPublicData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95427 31.0457 0 20 0C8.9543 0 0 8.95427 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#EDF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 12.4131C16.78 12.4131 13.9612 14.5888 13.1278 17.7177C12.2945 20.8468 13.7508 23.9908 16.4429 25.7687C17.3256 26.3517 17.4034 29.0091 17.4034 29.0091V30.7438C17.4034 32.2853 17.9585 32.7442 20.0002 32.787C22.0421 32.7443 22.5974 32.2853 22.5974 30.7438V29.0091C22.5974 29.0091 22.6745 26.3517 23.5577 25.7687C26.2498 23.9908 27.7063 20.8468 26.8728 17.7177C26.0393 14.5888 23.2203 12.4131 20.0002 12.4131Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 29.01V23.0949L17.2256 18.2607",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 29.0091V23.0941L21.7017 21.6533",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4033 29.0098V30.7444C17.4033 32.2859 17.9584 32.7448 20.0001 32.7877C22.042 32.745 22.5973 32.2859 22.5973 30.7444V29.0098H20.0001H17.4033Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8.67145V7.21289",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9346 9.99754L25.6614 8.73438",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5469 13.6219L29.8058 12.8926",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0657 9.99754L14.3389 8.73438",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4533 13.6219L10.1943 12.8926",
    stroke: "black",
    strokeWidth: 1.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublicData);
export default __webpack_public_path__ + "static/media/icon_public_data.360efd690ec7a837ba57c0711ccf2b5a.svg";
export { ForwardRef as ReactComponent };